<form [formGroup]="form" (ngSubmit)="login()">
  <div class="space-y-6">
    <!-- Phone Number Field -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ 'auth.username.label' | translate }}</mat-label>
      <input
        matInput
        type="tel"
        formControlName="phoneNumber"
        [placeholder]="'auth.username.placeholder' | translate"
        autocomplete="tel"
      />
      <mat-icon matSuffix>phone</mat-icon>
      @if (phoneNumber.hasError('required') && phoneNumber.touched) {
        <mat-error>{{ 'auth.username.required' | translate }}</mat-error>
      }
    </mat-form-field>

    <!-- Password Field -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ 'auth.password.label' | translate }}</mat-label>
      <input
        matInput
        [type]="hidePassword() ? 'password' : 'text'"
        formControlName="password"
        [placeholder]="'auth.password.placeholder' | translate"
        autocomplete="current-password"
      />
      <mat-icon matSuffix (click)="hidePassword.set(!hidePassword())" class="cursor-pointer">
        {{ hidePassword() ? 'visibility' : 'visibility_off' }}
      </mat-icon>
      @if (password.hasError('required') && password.touched) {
        <mat-error>{{ 'auth.password.required' | translate }}</mat-error>
      }
      @if (password.hasError('invalidCredentials')) {
        <mat-error>{{ 'auth.errors.invalidCredentials' | translate }}</mat-error>
      }
    </mat-form-field>

    <!-- Submit Button -->

    <div class="flex justify-end">
      <button class="btn btn-primary">Продовжити</button>
    </div>

    <!-- Form Error -->
    @if (form.hasError('invalidCredentials')) {
      <div class="text-error-600 text-sm text-center">
        {{ 'auth.errors.invalidCredentials' | translate }}
      </div>
    }
  </div>
</form>